import script from "./discountFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./discountFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./discountFormDialog.vue?vue&type=style&index=0&id=affc348c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-affc348c"]])

export default __exports__